import { render } from "./CampaignMenu.vue?vue&type=template&id=57fdface&scoped=true"
import script from "./CampaignMenu.vue?vue&type=script&lang=js"
export * from "./CampaignMenu.vue?vue&type=script&lang=js"

import "./CampaignMenu.vue?vue&type=style&index=0&id=57fdface&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fdface"]])

export default __exports__